import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import { ID8_TABS } from '../../../../constants';
import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import WithError from '../../../../components/with-error/WithError';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import useIsMessagesGenerating from '../../../hooks/useIsMessagesGenerating';

import scss from './RepliesForm.module.scss';

function RepliesFormInner({ onSubmit, disabled }) {
  const { t } = useTranslation('id8');

  const isFormLoading = useSelector((state) => state.id8.isFormLoading);
  const isResetting = useSelector((state) => state.id8.isResetting);
  const isGenerating = useIsMessagesGenerating();
  const id8Tab = useSelector((state) => state.id8.id8Tab);

  const isDisabled = disabled || isFormLoading || isResetting || id8Tab !== ID8_TABS.IDEAS || isGenerating;

  return (
    <div className={scss.repliesForm}>
      <Field name='hint'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('hints')} isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                isReadOnly
                rows='3'
                resize='vertical'
                isError={meta.touched && meta.error}
                disabled={isDisabled}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='reply'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('replies')} isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                rows='3'
                resize='vertical'
                isReadOnly={isFormLoading}
                isError={meta.touched && meta.error}
                disabled={isDisabled}
                onEnter={onSubmit}
                enableVoiceInput
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <TooltipButton
        type='submit'
        styleColor={BUTTON_STYLES.SECONDARY}
        onClick={onSubmit}
        maxWidth={140}
        disabled={isDisabled}
        tooltip={isGenerating && t('messagesGenerating')}>
        <Icon icon={ICONS.ArrowUp} />
      </TooltipButton>
    </div>
  );
}

export default RepliesFormInner;
